<template lang="pug">

  v-dialog(v-model="dialog" persistent :max-width="width")

    .dialogHeader

      .dialogHeaderTitle {{ title }}

      .dialogHeaderClose
        .dialogCloseButton.mdi.mdi-close(@click="close(closeWithAction ? selectedContent : false)")

    .dialogBody

      .dialogBodyContent(v-html="text")

      keyboard-shortcuts-info

    .dialogFooter(:class="{ 'text-right': buttonPosition === 'right', 'text-center': buttonPosition === 'center', 'text-left': buttonPosition === 'left' }")
        sos-button(@buttonClick="close(closeWithAction ? selectedContent : false)" size="medium" color="blue" :buttonLabel="args.closeText || 'Fechar'" buttonIcon="" buttonIconSize="16" :class="{ 'mr-3': isConfirm }")
        sos-button(v-if="isConfirm" @buttonClick="close(selectedContent)" size="medium" color="danger" :buttonLabel="args.continueText || 'Continuar'" buttonIcon="mdi-check-outline" buttonIconSize="16")

</template>

<script>
  import SosButton from '@/components/SosButton'
  import KeyboardShortcutsInfo from '@/components/KeyboardShortcutsInfo'

  export default {
    name: 'ConfirmDialog',
    components: {
      'sos-button': SosButton,
      'keyboard-shortcuts-info': KeyboardShortcutsInfo,
    },
    props: {
      buttonPosition: {
        type: String,
        default: () => 'right',
      },
      title: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        required: true,
      },
      width: {
        type: Number,
        default: () => 330,
      },
    },
    data () {
      return {
        args: {
          // title: '',
          // text: '',
          // type: '',
          // data: null,
          // isResponse: false,
          // buttonPosition: 'right',
          // width: 330,
          closeText: 'Fechar',
          continueText: 'Continuar',
        },
        dialog: false,
        isConfirm: false,
        selectedContent: false,
        closeWithAction: false,
      }
    },
    /* computed: {
    }, */
    watch: {
      dialog: {
        immediate: true,
        handler (newDialog, oldDialog) {
          // Se o modal foi fechado, remove o listener
          if (oldDialog === true && newDialog === false) {
            document.removeEventListener('keydown', this.handleKeydown)
          }
        },
      },
    },

    beforeDestroy () {
      // Remove o listener quando o componente for destruído
      document.removeEventListener('keydown', this.handleKeydown)
    },
    methods: {
      close (confirmed = false) {
        this.dialog = false
        this.$emit('close', confirmed)
      },

      open (selectedContent, confirm = true, closeWithAction = false) {
        this.dialog = true
        this.isConfirm = confirm
        this.selectedContent = selectedContent
        this.closeWithAction = closeWithAction

        this.args = {
          // title: '',
          // text: '',
          // type: '',
          // data: null,
          // isResponse: false,
          // buttonPosition: 'right',
          // width: 330,
          closeText: !!selectedContent.args === true && !!selectedContent.args.closeText === true ? selectedContent.args.closeText : 'Fechar',
          continueText: !!selectedContent.args === true && !!selectedContent.args.continueText === true ? selectedContent.args.continueText : 'Continuar',
        }

        // Adiciona listener para teclas quando modal abre
        this.$nextTick(() => {
          document.addEventListener('keydown', this.handleKeydown)
        })
      },

      handleKeydown (event) {
        // Se pressionar ENTER e modal estiver ativo
        if (event.key === 'Enter' && this.dialog) {
          event.preventDefault()
          if (this.isConfirm) {
            // Se for modal de confirmação, executa a ação principal
            this.close(this.selectedContent)
          } else {
            // Se for modal de resposta (só tem botão fechar), fecha o modal
            this.close(this.closeWithAction ? this.selectedContent : false)
          }
        }

        // Se pressionar ESC e modal estiver ativo
        if (event.key === 'Escape' && this.dialog) {
          event.preventDefault()
          this.close(this.closeWithAction ? this.selectedContent : false)
        }
      },
    },
  }
</script>


